import React from 'react'
import SecondaryButton from '../buttons/SecondaryButton'


const TitleDisplay = ({ text, saveDraft, categoryId, status }) => {

    const getHref = () => {
        switch (categoryId){
        case 237431:
            return 'autoala#/'
        case 284155:
            return 'oljyjatehuolto#/'
        case 386044:
            return 'tyokone#/'
        case 427415:
            return 'kestavapurkaminen#/'
        case 496637:
            return 'paastotontyomaa#/'
        case 522123:
            return 'varhaiskasvatus#/'
        case 583993:
            return 'rakentamisen-muovit#/'
        case 583645:
            return 'matsit/elintarvikeala#/'
        case 623511:
            return 'jatevesi#/'
        case 664314:
            return 'muoviset-annospakkaukset#/'
        case 664388:
            return 'muoviset-annospakkaukset#/'
        default:
            return 'tietoa-green-dealista#/'
        }
        
    }

    return(
        <div>
            <div className="flex-row items-center space-between border-bottom">
                <div>
                    <h1 className="h1">{text}</h1>
                    <a href={getHref()} target="_blank" rel="noopener noreferrer">Ohjeet lomakkeen täyttämiseksi</a>
                </div>
                {status !== 'approved' && (
                <SecondaryButton
                    action={() => saveDraft()}
                    textKey={'sit.commitmentCreation.saveDraft'}
                />
                )}
            </div>
        </div>
    )
}

export default TitleDisplay


// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/TitleDisplay.jsx